var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqlite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 228,
    viewBox: "0 0 201 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.888 9.95215H17.1499C7.71748 9.95215 0 17.671 0 27.1031V182.311C0 191.742 7.71748 199.46 17.1499 199.46H109.843C108.791 153.338 124.541 63.8312 157.888 9.95215Z",
    fill: "#0F80CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.775 14.9551H17.1498C10.4522 14.9551 5.00195 20.4039 5.00195 27.1027V170.986C35.7181 159.197 81.8192 149.025 113.695 149.487C120.101 115.994 138.927 50.3541 152.775 14.9551Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190.715 4.87245C181.076 -3.72335 169.405 -0.270529 157.887 9.95179C156.178 11.4705 154.472 13.1553 152.774 14.9551C133.07 35.8577 114.781 74.5759 109.099 104.145C111.312 108.634 113.041 114.362 114.18 118.738C114.472 119.86 114.735 120.914 114.945 121.81C115.446 123.932 115.714 125.307 115.714 125.307C115.714 125.307 115.538 124.639 114.813 122.537C114.675 122.134 114.521 121.694 114.339 121.176C114.261 120.962 114.153 120.702 114.035 120.424C112.75 117.436 109.194 111.13 107.63 108.384C106.291 112.332 105.108 116.026 104.118 119.367C108.635 127.632 111.388 141.796 111.388 141.796C111.388 141.796 111.15 140.878 110.014 137.674C109.007 134.841 103.988 126.046 102.799 123.99C100.765 131.499 99.9566 136.568 100.685 137.802C102.1 140.193 103.448 144.32 104.631 148.883C107.304 159.164 109.162 171.679 109.162 171.679C109.162 171.679 109.222 172.508 109.323 173.785C108.952 182.418 109.175 191.369 109.843 199.459C110.729 210.169 112.396 219.37 114.521 224.293L115.964 223.507C112.843 213.806 111.576 201.093 112.131 186.431C112.971 164.02 118.128 136.994 127.657 108.825C143.756 66.3018 166.092 32.1838 186.535 15.8904C167.903 32.7178 142.685 87.1867 135.135 107.357C126.683 129.945 120.693 151.141 117.083 171.449C123.311 152.41 143.45 144.227 143.45 144.227C143.45 144.227 153.328 132.045 164.871 114.641C157.956 116.218 146.602 118.918 142.799 120.516C137.19 122.869 135.678 123.672 135.678 123.672C135.678 123.672 153.849 112.606 169.439 107.596C190.879 73.828 214.237 25.8563 190.715 4.87245Z",
    fill: "#003B57"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 90.21,
    y1: 18.1482,
    x2: 90.21,
    y2: 162.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97D9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.920245,
    stopColor: "#0F80CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F80CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlite);
export default __webpack_public_path__ + "static/media/sqlite.913f7f7ebcf151bec5d363b131fb212f.svg";
export { ForwardRef as ReactComponent };